/* eslint-disable no-tabs */
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import BaseUrls from '../utils/baseUrls';
import Layout from '../components/common/layout';

const MainLayout = () => {
  const [theme, setTheme] = useState('');
  useEffect(() => {
    setTheme(BaseUrls.getkey());
  });
  return (
	<>
        <Layout>

          <Outlet />

        </Layout>
	</>
  );
};

export default MainLayout;
